// extracted by mini-css-extract-plugin
export default {"root":"EditButton_root__TqrBq","icon":"EditButton_icon__NHqbD"};